import script from "./BottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNav.vue?vue&type=script&setup=true&lang=js"

import "./BottomNav.vue?vue&type=style&index=0&id=9f794178&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f794178"]])

export default __exports__